import React from 'react'
import debounce from 'lodash.debounce'

import { DEFAULT_EMBEDS } from '../../providers/UserAPIProvider'
import { searchUser } from '../../lib/api'

export const DEBOUNCE_DELAY = 300
export const MIN_CHAR_COUNT = 2

const ID_DIFFS = (user, id) => user.id !== id
export const DEFAULT_FILTER = (res, _chars) => res
export const EXCLUDE_ME = id => (res, _chars) => {
  if (!res) {
    return []
  }
  return res.filter(user => ID_DIFFS(user, id()))
}

const useDelayedUserSearch = (
  external,
  process = DEFAULT_FILTER,
  embeds = DEFAULT_EMBEDS,
  debounceDelay = DEBOUNCE_DELAY
) => {
  const [results, setResults] = React.useState([])
  const [all, setAll] = React.useState([])
  const [error, setError] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const handleSearch = React.useCallback(
    async (chars, filters, sort, fields) => {
      try {
        setLoading(true)
        const all = await searchUser(
          chars,
          [],
          external,
          embeds,
          filters,
          sort,
          fields
        )
        setAll(all)
        const results = process(all, chars)
        setResults(results)
        setLoading(false)
        return results
      } catch (err) {
        console.error('Error with useDelayedSearch', err)
        setError({ err, auto: true })
      }
      return []
    },
    [external, embeds, process]
  )

  // eslint-disable-next-line
  const delayedSearch = React.useCallback(
    debounce(
      async (chars, filters, sort, fields) =>
        await handleSearch(chars, filters, sort, fields),
      debounceDelay,
      {
        leading: false
      }
    ),
    []
  )

  const onChars = React.useCallback(
    async (chars, cb, filters, sort, fields) => {
      if (chars.length > MIN_CHAR_COUNT) {
        const res = await delayedSearch(chars, filters, sort, fields)
        cb && cb(process(res, chars))
      } else {
        setAll([])
        setResults([])
      }
    },
    [delayedSearch, process]
  )

  return { search: onChars, results, all, error, loading }
}

export default useDelayedUserSearch
